"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var WhiteBirdBig = function WhiteBirdBig(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M179.557 435.68c2.098-.084 4.196-.21 6.295-.335 1.258-2.965 2.182-5.011 2.895-6.515l-.084-.041 21.15-49.615c-40.285-12.8-80.308-29.322-115.809-52.375-11.313-7.346-22.223-15.444-31.941-24.803L0 327.096c29.71 73.127 104.235 115.516 179.557 108.584M18.002 188.609c4.692 37.14 21.825 72.534 47.888 99.492 25.378 26.257 58.965 43.726 92.103 58.276 18.505 8.128 37.535 15.023 56.77 21.229 3.454-9.025 9.123-17.5 7.718-27.64-.882-6.322-4.558-11.584-8.536-16.404-8.178-9.902-16.407-19.762-24.61-29.647-18.75-22.59-39.79-44.754-53.33-70.923-13.936-26.92-22.366-58.694-20.944-89.135l-84.68-35.624c-12.014 28.14-16.802 60.026-12.379 90.376m639.674-84.153H487.531c-17.343 0-34.58-.184-51.81 2.405-41.677 6.248-81.835 25.154-111.268 55.479 0 0 0 .046.042.083-15.358-17.657-29.932-36.058-44.874-54.07-23.94-28.855-47.875-57.705-71.815-86.563L191.223 1.802c-50.88 41.73-74.127 110.965-59.104 174.825 6.768 28.762 20.813 53.803 39.6 76.414 6.835 8.227 13.667 16.463 20.498 24.694 10.046 12.1 20.092 24.206 30.138 36.31 4.863 5.855 9.382 12.015 11.54 19.436 4.074 14.037-2.103 26.528-7.604 39.128-9.077 20.785-17.8 41.73-26.697 62.59-11.17 26.198-22.332 52.4-33.498 78.594-.328.76-.65 1.52-.974 2.28 39.692 16.731 87.227 14.914 127.889 2.628 35.882-10.842 71.965-32.359 88.058-67.519 11.246-24.573 21.283-49.765 31.891-74.61 17.289-40.506 34.581-81.008 51.87-121.51l14.061-32.943c10.063-23.57 25.22-45.747 45.395-61.847 28.879-23.049 65.877-31.126 102.183-32.04 10.1-.255 20.217-.096 30.317-.096 4.138 0 8.238-.389 11.427-3.341 3.42-3.166 4.599-8.286 2.895-12.617-2.14-5.43-7.91-7.722-13.432-7.722",
    fill: "#FFF",
    fillRule: "evenodd",
    opacity: ".253"
  }));
};

WhiteBirdBig.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "672",
  height: "541",
  viewBox: "0 0 672 541"
};

var WhiteBirdMedium = function WhiteBirdMedium(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M117.3 284.279c1.37-.055 2.741-.136 4.112-.218.822-1.935 1.425-3.27 1.891-4.251l-.054-.027 13.816-32.374c-26.317-8.352-52.463-19.132-75.654-34.174-7.39-4.794-14.518-10.077-20.867-16.184L0 213.428c19.409 47.715 68.094 75.374 117.3 70.85M11.76 123.067c3.065 24.234 14.258 47.329 31.284 64.919 16.58 17.132 38.52 28.53 60.169 38.025 12.089 5.303 24.52 9.802 37.086 13.851 2.257-5.889 5.96-11.418 5.042-18.034-.576-4.126-2.977-7.56-5.576-10.704-5.343-6.461-10.719-12.895-16.078-19.345-12.248-14.74-25.993-29.202-34.839-46.277-9.104-17.565-14.61-38.297-13.682-58.16L19.847 64.097C12 82.458 8.871 103.264 11.76 123.067m417.883-54.91H318.492c-11.33 0-22.591-.12-33.847 1.57-27.227 4.076-53.46 16.412-72.688 36.199 0 0 0 .03.027.054-10.033-11.521-19.553-23.527-29.315-35.28a877843.93 877843.93 0 0 1-46.915-56.482L124.921 1.176C91.683 28.404 76.496 73.58 86.31 115.248c4.421 18.767 13.597 35.107 25.87 49.86 4.465 5.368 8.928 10.742 13.39 16.113 6.563 7.895 13.126 15.794 19.688 23.691 3.178 3.821 6.13 7.84 7.539 12.683 2.662 9.159-1.373 17.31-4.967 25.53-5.93 13.563-11.629 27.229-17.44 40.84-7.298 17.095-14.59 34.191-21.884 51.283-.214.496-.425.992-.636 1.488 25.93 10.916 56.983 9.73 83.546 1.714 23.441-7.074 47.013-21.114 57.526-44.056 7.347-16.034 13.904-32.471 20.834-48.682 11.294-26.43 22.591-52.858 33.885-79.285l9.186-21.495c6.574-15.38 16.475-29.85 29.655-40.355 18.866-15.04 43.036-20.31 66.754-20.906 6.598-.167 13.207-.063 19.805-.063 2.703 0 5.382-.254 7.465-2.18 2.234-2.066 3.004-5.407 1.891-8.232-1.398-3.543-5.167-5.039-8.774-5.039",
    fill: "#FFF",
    fillRule: "evenodd",
    opacity: ".2"
  }));
};

WhiteBirdMedium.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "439",
  height: "353",
  viewBox: "0 0 439 353"
};
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var zIndex = _ref.zIndex;
  return {
    root: {
      position: 'absolute',
      right: 0,
      top: 0,
      overflow: 'hidden',
      width: 512,
      height: 458,
      zIndex: zIndex.mobileStepper
    },
    bigBird: {
      position: 'absolute',
      right: -160,
      top: -70,
      opacity: 0.3
    },
    mediumBird: {
      position: 'absolute',
      right: -150,
      top: 95,
      opacity: 0.3
    }
  };
});

var WhiteBirdLogo = function WhiteBirdLogo() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.bigBird
  }, /*#__PURE__*/_react.default.createElement(WhiteBirdBig, null)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.mediumBird
  }, /*#__PURE__*/_react.default.createElement(WhiteBirdMedium, null)));
};

var _default = /*#__PURE__*/(0, _react.memo)(WhiteBirdLogo);

exports.default = _default;